<!--
  作者：顾先生
-->
<template>
  <div id="bottomLLB">
    <div class="bottomLLBBox">
      <div class="top">企商办由河北企商办企业管理咨询有限公司运营，主要为企业提供一体化知识产权服务。</div>
      <div class="bottom">郑重提醒：我们无需验证码等相关信息。如需填写银行卡号、验证码等相关信息，切勿相信，谨防上当受骗！
      </div>
    </div>
    <div class="bottomFont">备案号:冀ICP备2025098197号-3</div>
  </div>
</template>

<script>
export default {
  name: 'Bottom',
  // 注册组件
  components: {},
  // 注册方法
  methods: {},
  // 父子传值
  props: {},
  // 数据渲染
  data () {
    return {
      GSshow: false,
      XYshow: false
    }
  },
  // 计算属性
  computed: {},
  // 监听器
  watch: {},
  // 页面初次解析完成
  created () {
  },
  // 页面内容渲染完成
  mounted () {
  }
}
</script>

<style lang="less" scoped>
#bottomLLB {
  .bottomLLBBox {
    width: 345px;
    margin: 0 auto;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px 1px rgba(169, 112, 70, 0.52);
    border-radius: 10px;
    overflow: hidden;
  }

  .bottomFont {
    line-height: 32px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    text-align: center;
  }

  .top {
    width: 316px;
    font-weight: 500;
    font-size: 12px;
    color: #333333;
    background-color: #ffffff;
    padding: 10px 12px;
    line-height: 19px;
  }

  .bottom {
    width: 100%;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    background-color: #D92422;
    padding: 10px 12px;
    line-height: 19px;
  }
}
</style>
